export const initiateInstallPrompt = ()=>{

    return new Promise<Event>((resolve, reject)=>{

        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            // Update UI notify the user they can install the PWA
            resolve(e);
        });

    });
}
